// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c791469","732":"9ba71a7a","977":"1cfda090"}[chunkId] + ".chunk.js";
};